import React from "react";
import credentialsManifest from "../data/credentialsManifest.json";
import studioData from "../data/studioData.json";

const Credentials = () => {
  const credentialImages = Array.isArray(credentialsManifest.items) ? credentialsManifest.items : [];
  const credentialsContent = studioData.siteContent?.credentials ?? {};
  const { designation = "Professional Senior Architectural Technologist", registration = "SACAP, SAIAT" } =
    studioData.studioProfile ?? {};

  return (
    <section id="credentials" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12 md:py-16">
      <div className="glass-panel p-6 md:p-10">
        <div>
          <p className="section-kicker">{credentialsContent.kicker ?? "03 Credentials"}</p>
          <h2 className="mt-2 max-w-4xl text-4xl font-medium leading-[0.95] tracking-[-0.02em] text-white md:text-5xl lg:text-6xl">
            {credentialsContent.title ?? "Professional affiliations and accreditation"}
          </h2>
        </div>

        <div className="mt-8 grid gap-8 lg:grid-cols-[1.35fr_0.65fr] lg:gap-10 lg:items-start">
          <div className="space-y-5">
            {credentialImages.map((image) => {
              const imageUrl = `${process.env.PUBLIC_URL}/${image.path}`;
              return (
                <figure key={image.id} className="w-full">
                  <div className="glass-card overflow-hidden p-1">
                    <img
                      src={imageUrl}
                      alt="Professional registration credential"
                      loading="lazy"
                      className="block h-auto w-full border border-white/15"
                    />
                  </div>
                </figure>
              );
            })}
          </div>
          <div className="border-l border-white/20 pl-4 lg:mt-2">
            <div className="max-w-sm">
              <p className="text-sm tracking-[0.01em] text-text-secondary md:text-base">
                {designation}
              </p>
              <p className="mt-1 text-lg font-medium tracking-[0.02em] text-white md:text-2xl">
                {registration}
              </p>
            </div>
          </div>


        </div>
      </div>
    </section>
  );
};

export default Credentials;
